import * as React from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const dialogFooterVariants = cva('rocco-dialog-footer', {
    variants: {
        variant: {
            default: 'flex flex-col-reverse gap-2 sm:flex-row sm:justify-end',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DialogFooter = ({
    className,
    variant,
    ...props
}: React.HTMLAttributes<HTMLDivElement> &
    VariantProps<typeof dialogFooterVariants>) => (
    <div
        className={cn(dialogFooterVariants({ variant, className }))}
        {...props}
    />
);

DialogFooter.displayName = 'DialogFooter';
